module.exports = __webpack_public_path__ + "static/media/coin-avax.76d16e0f.png";